<app-thread-header
  [focused]="true"
  [resourceTypeDisplayName]="resourceToCreateThreadFor.resourceTypeDisplayName"
  [resourceDisplayName]="resourceToCreateThreadFor.resourceDisplayName"
></app-thread-header>

<div class="flex flex-row px-3 py-4 gap-3">
  @if (currentUser$ | async; as currentUser) {
    <app-commenting-user-logo
      [userId]="currentUser.user_id"
      [fallbackUserName]="currentUser.name"
    ></app-commenting-user-logo>
  }

  <div class="flex flex-col gap-3 flex-1">
    <app-savable-comment-input
      #input
      data-test-id="add-comment-input"
      class="w-full"
      [usersMap]="usersMap$ | async"
      [formControl]="textControl"
      [placeholder]="'commenting.addCommentPlaceholder' | translate"
      [focusOnInit]="true"
      [localStorageKey]="localStorageKey"
      [draftMessage]="draftMessage"
      [resourceToCreateThreadFor]="resourceToCreateThreadFor"
    ></app-savable-comment-input>

    <div class="flex gap-3">
      <app-new-button
        data-test-id="add-comment-btn"
        class="w-20"
        [type]="'primary'"
        [size]="'responsive'"
        [verticalSize]="'small'"
        [disabled]="textControl.invalid"
        [loading]="creationInProgress$ | async"
        (click)="commentClick()"
      >
        {{ buildTranslationKey('createThreadBtn') | translate }}
      </app-new-button>

      <app-new-button
        data-test-id="cancel-comment-adding-btn"
        class="w-20"
        [type]="'basic'"
        [size]="'responsive'"
        [verticalSize]="'small'"
        (click)="cancelClick()"
      >
        {{ buildTranslationKey('cancelBtn') | translate }}
      </app-new-button>
    </div>
  </div>
</div>
